<div class="profile-page">
  <h2 class="header">Profile</h2>
  <span>We use this information to pre-populate your timesheet and calculate your pay.</span>

  <div class="employee-info">
    <div class="imageIconContainer">
      @if (base64ProfilePhoto) {
        <ng-container [class.noBorder]="base64ProfilePhoto">
          <img src="{{base64ProfilePhoto}}" />
        </ng-container>
      }
      @if (!base64ProfilePhoto) {
        <div [class.noBorder]="base64ProfilePhoto">
          <i class="fa-solid fa-user" data-fa-transform="down-2" data-fa-mask="fa-solid fa-circle"></i>
        </div>
      }
    </div>
    <div class="ee-name-number">
      <h5 class="header ee-name">{{ profile.user.firstName + " " + profile.user.lastName }}</h5>
      <div>Employee #{{profile.user.employeeNumber}}</div>
    </div>
  </div>



  <h5 class="header">Employee status</h5>
  <div>{{ currentConfiguration.employmentStatus | unabbreviateEmploymentStatus }}</div>

  <h5 class="header">Unionized position?</h5>
  @if (currentConfiguration.unionCode=='Union') {
    <div>Yes</div>
  }
  @if (currentConfiguration.unionCode!=='Union') {
    <div>No</div>
  }

  <h5 class="header">Enrolled in the Compressed Day Off (CDO) program?</h5>
  @if (currentConfiguration.cdo) {
    <div>Yes</div>
  }
  @if (!currentConfiguration.cdo) {
    <div>No</div>
  }

  @if (currentConfiguration.cdo) {
    <h5 class="header">Scheduled CDO</h5>
    <div>{{ [currentConfiguration.cdoDay] | weekdayNames }} on Week {{currentConfiguration.cdoDay <= 7 ? '1' : '2' }} of the bi-weekly pay period</div>
    <h5 class="header">Adjusted hours day</h5>
    @if (currentConfiguration.cdo) {
      <div>{{ [currentConfiguration.modifiedDurationDay] | weekdayNames }} on Week {{ currentConfiguration.modifiedDurationDay <= 7 ? '1' : '2' }} of the bi-weekly pay period</div>
    }
    <h5 class="header">Compressed work schedule</h5>
    <table class="schedule">
      <tr>
        <td></td>
        <th class="header cell blue border-top-bottom border-left">Sat</th>
        <th class="header cell blue border-top-bottom">Sun</th>
        <th class="header cell blue border-top-bottom">Mon</th>
        <th class="header cell blue border-top-bottom">Tue</th>
        <th class="header cell blue border-top-bottom">Wed</th>
        <th class="header cell blue border-top-bottom">Thu</th>
        <th class="header cell blue border-top-bottom">Fri</th>
        <th class="header cell black border-top-bottom border-right border-left">Total</th>
      </tr>
      <tr>
        <td class="cell border-right">Week 1</td>
        @for (workDayHours of week1WorkHours; track 'wk1' + $index; let i = $index) {
          <!--cdoDay is 1-based but index is zero-based-->
          @if ((i+1) !== currentConfiguration.cdoDay) {
            <td class="cell border-top-bottom" [class.bold]="(i+1) == currentConfiguration.modifiedDurationDay">{{workDayHours | formatHoursDecimals}} hrs</td>
          }
          @if ((i+1) == currentConfiguration.cdoDay) {
            <td class="cell border-top-bottom bold">CDO</td>
          }
        }
        <td class="cell total border-left border-right">{{ week1TotalHours | formatHoursDecimals}} hrs</td>
      </tr>
      <tr>
        <td class="cell border-right">Week 2</td>
        @for (workDayHours of week2WorkHours; track 'wk2' + $index; let i = $index) {
          @if ((i+8) !== currentConfiguration.cdoDay) {
            <td class="cell border-top-bottom" [class.bold]="(i+8) == currentConfiguration.modifiedDurationDay">{{workDayHours | formatHoursDecimals}} hrs</td>
          }
          @if ((i+8) == currentConfiguration.cdoDay) {
            <td class="cell border-top-bottom bold">CDO</td>
          }
        }
        <td class="cell total border-top-bottom border-left border-right">{{ week2TotalHours | formatHoursDecimals }} hrs</td>
      </tr>
      <tr>
        <td colspan="8"></td>
        <td class="cell total bold border-top-bottom border-left border-right"> {{ week1TotalHours + week2TotalHours | formatHoursDecimals}} hrs</td>
      </tr>
    </table>
  }



  <div class="info-dropdown">
    <div class="info-dropdown-visible" (click)="infoDropdownOpen=!infoDropdownOpen">
      <div>
        <i class="fa-light fa-calendar-week fa-xl"></i>
        <p class=" dropdown-title">How does the bi-weekly pay period work?</p>
      </div>
      @if (!infoDropdownOpen) {
        <div><i class="fa-sharp fa-solid fa-plus plusminus fa-xl"></i></div>
      }
      @if (infoDropdownOpen) {
        <div><i class="fa-sharp fa-solid fa-minus plusminus fa-xl"></i></div>
      }
    </div>
    @if (infoDropdownOpen) {
      <div class="info-dropdown-hidden">
        <p>At the District, the bi-weekly pay period starts on a Saturday and ends on the second Friday.</p>
        <img class="pay-periods-img" src="/assets/images/pay-periods.png" title="Bi-weekly pay periods">
        <p>Employees get paid on the Friday following the bi-weekly pay period. For example, you get paid on September 19 for your hours from August 30 to September 12.</p>
      </div>
    }
  </div>
</div>